import { AgGridReact } from "ag-grid-react";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { Box, Group } from "@mantine/core";
import DeviceIcon from "./SelectedSpace/DeviceIcon";
import { IDeviceCategoryEnum, IMcBimItem } from "@backend/src/schemas";

/*
export const COMP_CODE_PATH = "psets.NONS_Reference.RefCompType";
*/

const McBimItemsCompTable: React.FC<{ mcbimItems: IMcBimItem[]; compCodePath: string }> = ({
  mcbimItems,
  compCodePath,
}) => {
  const columns: ColDef<IMcBimItem>[] = [
    {
      field: "_id",
      hide: true,
    },
    {
      field: "deviceCategory",
      hide: true,
      sort: "desc",
    },
    {
      field: compCodePath as any,
      headerName: "CompCode",
      width: 140,
      cellRenderer: (params: ICellRendererParams<IMcBimItem>) => {
        return (
          <Group>
            <DeviceIcon deviceType={params.data?.deviceCategory as IDeviceCategoryEnum} />
            <span>{params.value ?? "-"}</span>
          </Group>
        );
      },
    },
    {
      field: "type.name",
      headerName: "Beskrivelse",
      flex: 1,
    },
  ];

  return (
    <Box h="100%">
      <div className="ag-theme-quartz" style={{ overflow: "auto", height: "100%", width: "100%" }}>
        <AgGridReact
          columnDefs={columns}
          rowData={mcbimItems}
          getRowId={(p) => p.data._id as unknown as string}
        />
      </div>
    </Box>
  );
};

export default McBimItemsCompTable;
